/* tslint:disable:jsx-no-lambda */
/* eslint-env browser */
import '@ta-interaktiv/semantic-ui/semantic/dist/components/button.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import config from 'config'
import { interpolateCubehelix } from 'd3-interpolate'
import { scaleLinear } from 'd3-scale'
import React from 'react'
import { Axis } from 'types/Axis'
import './styles.scss'

interface IProps {
  handleDivHeight: (arg0: number) => void
  question: string
  reversed: boolean
  questionIndex: number
  style: React.CSSProperties
  axis: Axis
}

export interface ISelectionProps {
  selection?: number
}

export interface IHandlerProps {
  handleAnswer: (questionIndex: number, answer: number, axis: Axis) => void
}

const color = scaleLinear()
  .domain([0, 3, 6])
  // @ts-ignore
  .range(['#4D9221', '#AAA', '#C51B7D'])
  .interpolate(interpolateCubehelix)

export function Question(props: IProps & ISelectionProps & IHandlerProps) {
  const questionNumber = props.questionIndex + 1
  const responses = props.reversed ? config.revertedResponses : config.responses

  return (
    <div className={'question ui text container'}>
      <h3 className='header'>
        <div className='number'>Question {questionNumber}</div>
        <div className='intro'>
          Êtes-vous d’accord avec les affirmations suivantes?
        </div>
        <div className='question'>«{props.question}»</div>
      </h3>

      <div className='ui center aligned vertical very fitted segment'>
        <div className='ui vertical labeled icon basic buttons'>
          {responses.map(([response, value], index) => (
            <button
              onClick={() =>
                props.handleAnswer(props.questionIndex, value, props.axis)
              }
              className='ui button'
              key={response}
            >
              <i
                className={`${
                  props.selection === value
                    ? 'check circle grey'
                    : 'circle outline grey'
                } icon`}
              />
              <span style={{ color: color(index) }}>{response}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}
